module.exports = __webpack_public_path__ + "static/media/u13_3.304c55dd.mp3";